export const RmaSearchPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">RMA 검색</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-info color2 w-170px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt="" /> 엑셀 양식 다운로드</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>RMA포함</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">등록기간</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="position-relative">

                <div className="content_wrap">
                    <div className="table_top">
                        <h6 className="table_stats">RMA 목록(<span>13</span>건)</h6>
                        <div className="table_toolbar">
                            <button className="btn btn-outline-dark w-150px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                            <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>

                            <button className="btn btn-success ms-40px px-0">RMA 생성</button>
                            <button className="btn btn-outline-success px-0">RMA 삭제</button>
                        </div>
                    </div>

                    <div className="table_scroll">
                        <table className="table table-bordered my_table">
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ width: "4.4%" }}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </th>
                                    <th style={{ width: "11.94%" }} rowSpan={2}>RMA 일자</th>
                                    <th style={{ width: "11.94%" }} rowSpan={2}>담당자</th>
                                    <th style={{ width: "23.89%" }} colSpan={2}>고객</th>
                                    <th style={{ width: "11.94%" }} rowSpan={2}>규격</th>
                                    <th style={{ width: "11.94%" }} rowSpan={2}>COA구분</th>
                                    <th style={{ width: "11.94%" }} rowSpan={2}>수량</th>
                                    <th rowSpan={2}>상태</th>
                                </tr>
                                <tr>
                                    <th style={{ width: "11.94%" }}>거래처</th>
                                    <th style={{ width: "11.94%" }}>담당</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                    <tr className={index < 9 ? "lightblue" : ""}>
                                        <td className="text-center">
                                            <div className="checkbox_outer">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={index < 9}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">2024.01.10</td>
                                        <td className="text-center">김민성</td>
                                        <td className="text-center">(주) 구구구</td>
                                        <td className="text-center">김예리 대리</td>
                                        <td className="text-center">MUV-1234</td>
                                        <td className="text-center">TN COA</td>
                                        <td className="text-end">160</td>
                                        <td className="text-center text-primary">활성</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination-container">
                        <ul>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                    alt="First Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                    alt="Previous Page"
                                    className=""
                                />
                            </li>
                            <li className="active">1</li>
                            <li className="">2</li>
                            <li className="">3</li>
                            <li className="">4</li>
                            <li className="">5</li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                    alt="Next Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                    alt="Last Page"
                                    className=""
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
